export default {
  welcome: 'Bienvenido',
  dearUser: 'Estimado usuario',
  goBack: 'Regresar',
  setNumber: 'Ya puedes pagar o activar tu Débito Automático Mensual de tu línea móvil y Claro Hogar de manera fácil y segura.',
  subTextSetNumber: 'Digita el número o código de tu servicio',
  NOT_CLARO_NUMBER: 'El Teléfono ingresado es incorrecto o no pertenece a Claro',
  app: 'https://play.google.com/store/apps/details?id=com.recarga.saldo1.claro.app',
  maintenance: 'El portal se encuentra en mantenimiento por el momento. Estamos trabajando para brindarte un mejor servicio.',
  homeInstructions: 'Selecciona el tipo de número',
  inputLabel: 'Digita el número o código de tu servicio',
  changeRecurrenceNotifications: {
    title: '¡No olvides confirmar!',
    msg: 'Para completar tu activación de débito automático mensual, hemos enviado una solicitud de confirmación a tu correo.',
    inputLabel: 'Introduce tu número móvil Claro para recibir notificaciones de cobro.'
  },
  payFirstDueInvoices: 'Debes pagar primero tus facturas vencidas para continuar',
  noInvoicesNow: 'No tienes facturas por el momento.',
  satisfactionMsg: 'Tu satisfacción nos impulsa a mejorar nuestros servicios. Te deseamos éxito en el alcance y logro de tus metas. Recuerda que estamos para servirte.',
  exit: 'Salir',
  finalize: 'Finalizar',
  accept: 'Aceptar'
};
